export interface IOption<T> {
  key: T;
  name?: string;
  label: string;
}

export class Dictionary<T> {
  options: IOption<T>[] = [];

  constructor(options: IOption<T>[]) {
    this.options = options;
  }

  name(key?: T | string) {
    const option = this.options.find((o) => o.key === key);
    return option ? option.name : "";
  }

  label(key?: T | string) {
    const option = this.options.find((o) => o.key === key);
    return option ? option.label : "";
  }

  labelOrKey(key?: T | string) {
    const option = this.options.find((o) => o.key === key);
    return option ? option.label : key;
  }

  get namedOptions() {
    return this.options.flatMap((option) =>
      option.name ? [{ key: option.key, label: option.name }] : []
    );
  }
}
